import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { clearSymbolMappingFilterEpic } from './_epics/clearSymbolMappingFilter.epic';
import { initSymbolMappingFilterEpic } from './_epics/initSymbolMappingFilter.epic';
import { setSymbolMappingFilterEpic } from './_epics/setSymbolMappingFilter.epic';

export const symbolMappingFilterEpic = safeCombineEpics(
  clearSymbolMappingFilterEpic,
  initSymbolMappingFilterEpic,
  setSymbolMappingFilterEpic,
);
